"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _history = require("history");

var _createMemoryHistory = require("./_createMemoryHistory");

var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (!props.cache) {
        return (0, _history.createMemoryHistory)(props);
    }

    return (0, _createMemoryHistory2.default)(props);
};


//////////////////
// WEBPACK FOOTER
// ./packages/bone-web@0.2/node_modules/_@bone_web-router@0.2.0-alpha.1@@bone/web-router/lib/history/createMemoryHistory.js
// module id = 2513
// module chunks = 4